import formGroupVod from './formGroupVod';
import formGroupVoDOptimizationSettings from './formGroupVoDOptimizationSettings';
import formGroupVoDEncodingSettings from './formGroupVoDEncodingSettings';
import { storeStructure } from '../store/reducers';
import formGroupVodGraphicManager from './formGroupVodGraphicManager';

export default {
  title: 'VoD Graphic manager Creation',
  attributeName: "VodGraphicManagerNew",
  createURL: '',
  sessionParams: [],
  getURL: 'vodgraphicmanager',
  updateURL: 'vodgraphicmanager',
  idAttribute: 'id',
  noArea: true,
  goBack: true,
  autoUpdate: false,
  formConfig: [
    formGroupVodGraphicManager,
  ],
};
